<div class="modal-container overflow-auto flex-1 flex flex-col relative p-base">
  <!-- Close Btn -->
  <div class="absolute cursor-pointer top-2xs right-base text-txt">
    <svg-icon key="close" class="!text-2xs" (click)="dialogRef.close()"></svg-icon>
  </div>

  @if (!isLoading) {
    <div class="text-base leading-base font-semibold">
      {{ employeeDetails?.employeeName }}
    </div>
    <div class="mt-2xs text-sm leading-sm text-txt">
      {{ employeeDetails?.locationName }}
    </div>
    <div
      title=""
      class="mt-base w-full flex-1 overflow-auto beautyScroll border border-ui-separator rounded-sm"
    >
      <table #table mat-table [dataSource]="dataSource" matSort class="shadow-e1 w-max border-separate">
        <ng-container matColumnDef="clockIn">
          <th mat-header-cell *matHeaderCellDef>Clock</th>
          <td mat-cell *matCellDef="let element">
            <div class="flex flex-col">
              <span>{{ element.clockIn }}</span>
              <span>{{ element.clockOut }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th class="!text-right" mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let element">
            <div class="flex items-center justify-end">
              @if (element.isValid === false) {
                <div class="flex mr-sm !text-error-light">
                  <svg-icon key="warning-diamond" class="!text-xs"></svg-icon>
                </div>
              }
              <span>{{ element.total }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="locationName">
          <th mat-header-cell *matHeaderCellDef>Location Name</th>
          <td class="w-[220px]" mat-cell *matCellDef="let element">
            {{ element.locationName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="timeZone">
          <th mat-header-cell *matHeaderCellDef>Time Zone</th>
          <td mat-cell *matCellDef="let element">
            {{ element.timeZone }}
          </td>
        </ng-container>
        <ng-container matColumnDef="note">
          <th mat-header-cell *matHeaderCellDef>Note</th>
          <td class="max-w-[130px]" mat-cell *matCellDef="let element">
            {{ element.note }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr class="pivote-table-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  } @else {
    <div class="py-2xl self-center flex justify-center">
      <mat-progress-spinner [diameter]="60" mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</div>
